/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DashboardStub from '../../DashboardStub';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

export default function WidgetTable({ headCells, rows, emptyMessageId }) {
  const t = useLocalizedMessage();
  if (rows.length === 0) {
    return <DashboardStub variant="table" compact messageId={emptyMessageId} />;
  }

  return (
    <TableContainer>
      <Table size="small" aria-label={t('table.accessible.compact')}>
        <TableHead>
          <TableRow>
            {
              headCells.map((e) => (
                <TableCell key={e.id} align={e.align || (e.numeric ? 'right' : 'left')}>
                  {typeof e.label === 'string' && e.label.includes('.') ? t(e.label) : e.label}
                </TableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={`${row.id ?? 'row'}:${i}`}>
              {
                headCells[0].label === '#'
                  ? <TableCell>{i + 1}</TableCell>
                  : null
              }
              {
                headCells[0].label === '#'
                  ? headCells.slice(1).map((cell) => (
                    <TableCell key={cell.id} align={cell.align || (cell.numeric ? 'right' : 'left')}>
                      {typeof cell.render === 'function'
                        ? cell.render(row[cell.id], row)
                        : row[cell.id]}
                    </TableCell>
                  ))
                  : headCells.map((cell) => (
                    <TableCell key={cell.id} align={cell.align || (cell.numeric ? 'right' : 'left')}>
                      {typeof cell.render === 'function'
                        ? cell.render(row[cell.id], row)
                        : row[cell.id]}
                    </TableCell>
                  ))

              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

WidgetTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  headCells: PropTypes.arrayOf(PropTypes.object).isRequired,
  emptyMessageId: PropTypes.string,
};

WidgetTable.defaultProps = {
  emptyMessageId: 'search.health.preview.noData',
};
